(function () {
  var d = document;
  /* reviews: sort, load more, write-a-review toggle (only real, approved reviews are ever rendered) */
  var kr = d.getElementById('KReviews');
  if (kr) {
    var krForm = kr.querySelector('.KReviewForm');
    if (krForm && krForm.querySelector('.KReviewForm__Thanks, .KReviewForm__Error')) { krForm.classList.add('is-open'); }
    kr.querySelectorAll('[data-k-review-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', krForm && krForm.classList.contains('is-open') ? 'true' : 'false');
      b.addEventListener('click', function () { if (!krForm) return; var o = krForm.classList.toggle('is-open'); b.setAttribute('aria-expanded', o ? 'true' : 'false'); if (o) { var f = krForm.querySelector('input[type=radio]'); setTimeout(function () { krForm.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); if (f) f.focus({ preventScroll: true }); }, 60); } });
    });
    var krList = kr.querySelector('[data-k-review-list]'), krMore = kr.querySelector('[data-k-review-more]'), krShown = kr.querySelector('[data-k-review-shown]'), krSort = kr.querySelector('[data-k-review-sort]');
    if (krList) {
      if (krSort && !krList.querySelector('[data-photo="1"]')) { var po = krSort.querySelector('option[value=photo]'); if (po) po.remove(); }
      var KR_PAGE = 6, krLimit = KR_PAGE;
      var krPaint = function () {
        var items = Array.prototype.slice.call(krList.children), mode = krSort ? krSort.value : 'new';
        var pool = items.filter(function (li) { return mode !== 'photo' || li.dataset.photo === '1'; });
        items.forEach(function (li) { if (pool.indexOf(li) < 0) li.classList.add('is-hidden'); });
        pool.sort(function (a, b) { var ra = +a.dataset.rating, rb = +b.dataset.rating, da = +a.dataset.date, db = +b.dataset.date; if (mode === 'high') return rb - ra || db - da; if (mode === 'low') return ra - rb || db - da; return db - da; });
        pool.forEach(function (li, i) { krList.appendChild(li); li.classList.toggle('is-hidden', i >= krLimit); });
        if (krShown) krShown.textContent = Math.min(krLimit, pool.length);
        if (krMore) krMore.parentNode.hidden = pool.length <= krLimit;
      };
      if (krSort) krSort.addEventListener('change', function () { krLimit = KR_PAGE; krPaint(); });
      if (krMore) krMore.addEventListener('click', function () { krLimit += KR_PAGE; krPaint(); });
      krPaint();
    }
  }
})();
